import {Component, OnInit} from '@angular/core';
import {RequirementFullDTO} from '../../../../services/api/api';
import {BookingEditorService} from '../../../../services/booking-editor/booking-editor.service';

@Component({
  selector: 'sb-commercial-editor-requirements',
  templateUrl: './sb-commercial-editor-requirements.component.html',
  styleUrls: ['./sb-commercial-editor-requirements.component.scss'],
  standalone: false,
})
export class SbCommercialEditorRequirementsComponent implements OnInit {
  requirements: RequirementFullDTO[];
  selectedRequirement: RequirementFullDTO;

  constructor(public bookingEditor: BookingEditorService) {}

  ngOnInit(): void {
    this.requirements = this.bookingEditor?.editingRecord?.get('commercial')?.requirements;
  }
}
